import React from 'react';

export default class ConvertableActionBar extends React.Component {
  constructor(props) {
    super(props);
    this.closeDialog = this.closeDialog.bind(this);
  }

  closeDialog() {
    window.editor.dialogManager.closeCurrentDialog();
  }

  render() {
    return (
      <div className='mobile-tour-action'>
        <div className='left-controls'>
          <input id='dont-show' type='checkbox' data-role='seen-mobile-tour-checkbox' />
          <label htmlFor='dont-show'>Don&apos;t show this message again</label>
        </div>
        <div className='right-controls clearfix actions'>
          <a
            href='#'
            className='button action blue right'
            onClick={this.closeDialog}
          >
            <span>Got It</span>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/mobile-tour/convertable-action-bar.jsx